import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import './decks.css';
import Deck from '../deck/Deck';
import { Modal, Button } from 'react-bootstrap';
import { notifyError, notifySuccess } from '../Notification';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDecks, createDeck } from '../../redux/decksSlice';

const Decks = ({ selectedBusiness }) => { // Add selectedBusiness prop
    const [showModal, setShowModal] = useState(false);
    const [deckName, setDeckName] = useState("");

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const { items: userBusinesses } = useSelector((state) => state.userBusinesses);
    const userEmail = localStorage.getItem('user');
    const dispatch = useDispatch();
    const { items: decks, loading, error } = useSelector(state => state.decks);

    // Use prop instead of localStorage for real-time updates
    const selectedBusinessId = selectedBusiness || localStorage.getItem("selectedBusinessId");
    
    useEffect(() => {
        // Fetch decks when userEmail or selectedBusiness changes
        console.log('Decks useEffect triggered:', { userEmail, selectedBusinessId });
        
        if (userEmail && selectedBusinessId && selectedBusinessId !== "All") {
            console.log('Dispatching fetchDecks with:', { userEmail, selectedBusinessId });
            dispatch(fetchDecks({ userEmail, selectedBusinessId }));
        } else {
            console.log('Skipping fetchDecks - missing requirements:', { 
                hasUserEmail: !!userEmail, 
                hasBusinessId: !!selectedBusinessId, 
                isNotAll: selectedBusinessId !== "All" 
            });
        }
    }, [userEmail, selectedBusinessId, dispatch]); // Add selectedBusiness to dependencies

    // Create deck action
    const handleCreateDeck = () => {
        if (!deckName.trim()) {
            alert("Please enter a deck name.");
            return;
        }
        // Use the current selectedBusinessId for creating deck
        dispatch(createDeck({ deckName, selectedBusinessId }));
        handleClose();
        setDeckName(""); // Clear the input
    }

    // Count running decks for the toolbar
    const runningDecks = decks.filter(deck => deck.status === 'running' || deck.sitesRunning > 0).length;

    // Update the toolbar count via a custom event (for parent component)
    useEffect(() => {
        const event = new CustomEvent('deckCountUpdate', {
            detail: { total: decks.length, running: runningDecks }
        });
        window.dispatchEvent(event);
    }, [decks.length, runningDecks]);

    if (loading) return (
        <div className="loading-state">
            <p>Loading decks...</p>
        </div>
    );
    
    if (error) return (
        <div className="error-state">
            <p>Error: {error}</p>
        </div>
    );

    // Handle "All" businesses case
    if (selectedBusinessId === "All") {
        return (
            <div className="modern-decks-container">
                <div className="empty-state-content">
                    <p>Please select a specific business to view decks</p>
                    <p className="empty-subtitle">Decks are business-specific</p>
                </div>
            </div>
        );
    }

    return (
        <div className="modern-decks-container">
            {userBusinesses.length === 0 ? (
                <div className="decks-no-business">
                   Please create a new business by navigating to Manage Businesses in the filters above.
                </div>
            ) : (
                <>
                    {/* Modern Table - replaces the old bootstrap table */}
                    <div className="decks-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Deck Name</th>
                                    <th>Sites Running</th>
                                    <th>Deck Actions</th>
                                    <th>Assign to Site</th>
                                </tr>
                            </thead>
                            <tbody>
                                {decks.length === 0 ? (
                                    <tr>
                                        <td colSpan={4} className="empty-decks">
                                            <div className="empty-state-content">
                                                <p>No decks found for this business</p>
                                                <p className="empty-subtitle">Create your first deck to get started</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    decks.map((deck, index) => (
                                        <Deck
                                            key={deck.deckId || index}
                                            deck={deck}
                                        />
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Create Deck Modal */}
                    <Modal show={showModal} onHide={handleClose} size='lg' centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Create a New Deck</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="form-group">
                                <label htmlFor="deck-name">Deck Name</label>
                                <input 
                                    id="deck-name"
                                    type="text"
                                    placeholder="Enter Deck Name"
                                    className="form-control"
                                    value={deckName}
                                    onChange={(e) => setDeckName(e.target.value)}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            handleCreateDeck();
                                        }
                                    }}
                                />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button 
                                variant="primary" 
                                onClick={handleCreateDeck}
                                disabled={!deckName.trim()}
                            >
                                Create Deck
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}
        </div>
    );
};

export default Decks;